import React from 'react';
import { useMeasure } from 'react-use';
import { styled } from 'styled-components';
import { useOneWayTimeoutToggle } from './use-one-way-timeout-toggle';
import { jsx as _jsx } from "react/jsx-runtime";
const timeoutDuration = 250;
export const Collapsible = ({
  children,
  isOpen
}) => {
  const [ref, {
    height: contentHeight
  }] = useMeasure();
  const overflow = useOneWayTimeoutToggle(['hidden', 'inherit'], isOpen, timeoutDuration);
  const visibility = useOneWayTimeoutToggle(['visible', 'hidden'], !isOpen, timeoutDuration);
  return /*#__PURE__*/_jsx(Container, {
    style: {
      height: `${isOpen ? contentHeight : 0}px`,
      overflow
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      style: {
        visibility
      },
      children: children
    })
  });
};
const Container = styled.div.withConfig({
  displayName: "Collapsible__Container",
  componentId: "sc-cln1vp-0"
})(["will-change:height,overflow;transition:height ease-in-out ", "ms;"], timeoutDuration);